'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'clarinet';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f8ad';
var svgPathData = 'M630.6 22.6c10.2-10.2 12.3-25.9 5.2-38.4S614.2-34.5 600.2-31L472.2 1c-5.6 1.4-10.8 4.3-14.9 8.4L142.7 324c-10.5 10.5-23.4 18.5-37.5 23.2L37.9 369.6c-10.5 3.5-18.5 12.2-21 23s.7 22.1 8.5 30l112 112c7.8 7.8 19.2 11.1 30 8.5s19.5-10.5 23-21l22.4-67.3c4.7-14.1 12.7-27 23.2-37.5L630.6 22.6zM208 328a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-40a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faClarinet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;